import React from 'react';
import { Tag } from '@bedrock/components';
import type { TagColor } from '@bedrock/components/lib/Tag';
import type { RechargeStateEnum } from '#services/api';
import { RECHARGE_STATUS_DESC } from '../constants';

/**
 * 充值单状态 → Bedrock Tag 颜色。
 * 对齐退款 REFUND_STATE_MAP.tagColor（orange=待发起 / brand=确认中 / green=完成 / grey=废弃）。
 */
const RECHARGE_STATE_TAG_COLOR: Record<
  string,
  'orange' | 'brand' | 'green' | 'grey'
> = {
  PENDING_PLANNER_INITIATE: 'orange',
  PENDING_OPTIMIZER_INITIATE: 'orange',
  PENDING_SUPPLIER_INITIATE: 'orange',
  PLANNER_CONFIRM: 'brand',
  OPTIMIZER_CONFIRM: 'brand',
  PRINCIPAL_CONFIRM: 'brand',
  SUPPLIER_CONFIRM: 'brand',
  COMPLETED: 'green',
  ABANDONED: 'grey',
};

const DEFAULT_TAG_COLOR = 'grey';

interface RechargeStatusTagProps {
  status?: RechargeStateEnum;
  /** 状态中文文案（默认取 RECHARGE_STATUS_DESC，传值可覆盖） */
  text?: string;
}

/**
 * 充值单状态 Tag（内/外包确认页 + 批量审批复用）。
 * 用 Bedrock <Tag color="light-xxx">（对齐退款 RefundStatusTag），
 * 避免自定义 span + Tailwind 颜色 class 在项目里不生效（渲染成灰色）的问题。
 */
export const RechargeStatusTag: React.FC<RechargeStatusTagProps> = ({
  status,
  text,
}) => {
  const tagColor = status
    ? RECHARGE_STATE_TAG_COLOR[status] ?? DEFAULT_TAG_COLOR
    : DEFAULT_TAG_COLOR;
  const label = text ?? (status ? RECHARGE_STATUS_DESC[status] : undefined);
  return (
    <Tag
      text={label ?? status ?? '未知状态'}
      size="small"
      color={`light-${tagColor}` as TagColor}
    />
  );
};

export default RechargeStatusTag;
